import React, { Component } from "react";

import { Button } from 'antd';
import WidgetAjax from "../../widget/WidgetAjax";
import Config from "../../config/Config";
import './../../css/frame.css';
import './../../css/project.css';
import './index.scss';

class Index extends Component {

    constructor(props) 
    {
        super(props);

        this.state = {
            userInfo: {},
            industryInfo: {},
            pageInfo: {},
            pageList: []
        }
    }
    componentDidMount(){
        this.querySqHisList(this.props.location.state.SQID)
        this.getUserInfo()
        this.queryAuditList(this.props.location.state.SQID)
    }
    getUserInfo(){
        let userInfo =localStorage.getItem("_user_info_")
        if(userInfo){
            let info = JSON.parse(userInfo)
            this.setState({
                userInfo: info
            })
            this.queryEntinfo(info)
        }

    }
    queryEntinfo(info){
        WidgetAjax.ajax({
            url : Config.getBasePath()+'/entsq/entinfo', 
            params : {
                UNISCID: info.uniscid
            }, 
            callback : (data)=>{
                if(data&&data.status === 0){
                    this.setState({
                        industryInfo: data.result || {}
                    })
                    
                }
            }
        },this);
    }
    querySqHisList(SQID){
        WidgetAjax.ajax({
            url : Config.getBasePath()+'/entsq/info', 
            params : {
                SQID
            }, 
            callback : (data)=>{
                if(data&&data.status === 0){
                    this.setState({
                        pageInfo: data.result
                    })
                }
            }
        },this);
    }
    queryAuditList(SQID){
        WidgetAjax.ajax({
            url : Config.getBasePath()+'/entsq/audit_list', 
            params : {
                SQID,
                INFO:'INFO'
            }, 
            callback : (data)=>{
                if(data&&data.status === 0){
                    data.results.forEach(da => {
                        // if(da.HJMC==='县审核'){
                        //     da.HJMC = '[县级]审核通过'
                        // }else if(da.HJMC==='县报送'){
                        //     da.BLJG = ''
                        //     da.HJMC = '[市级]待审核'
                        // }else if(da.HJMC==='县审核驳回'){
                        //     da.HJMC = '[县级]驳回'
                        // }else if(da.HJMC==='县审核退回'){
                        //     da.HJMC = '[县级]退回'
                        // }else if(da.HJMC==='市报送'){
                        //     da.BLJG = ''
                        //     da.HJMC = '[省级]待审核'
                        // }else if(da.HJMC==='市报送退回'){
                        //     da.HJMC = '[市级]退回'
                        // }else if(da.HJMC==='市报送驳回'){
                        //     da.HJMC = '[市级]驳回'
                        // }else if(da.HJMC==='省审核'&&!da.BLJG){
                        //     da.HJMC = '[省级]待审核'
                        // }else if(da.HJMC==='省报送驳回'){
                        //     da.HJMC = '[省级]驳回'
                        // }else if(da.HJMC==='总局'){
                        //     da.HJMC = '认定入库'
                        // }else{
                            
                        // }
                        
                        let str = da.BLJG
                        da.HJMC = str.replace('市报送退回','退回').replace('县审核驳回','驳回').replace('县审核退回','退回').replace('省审核通过','认定入库').replace('市报送通过','待审核').replace('待审核通过','待审核').replace('市报送驳回','驳回').replace('省审核驳回','驳回').replace('省报送驳回','驳回').replace('县报送通过','待审核').replace('市审核退回','退回')
                        if(da.BLJG.indexOf('通过')>-1){
                            da.BLJG = '通过'
                        }else if(da.BLJG.indexOf('退回')>-1){
                            da.BLJG = '退回'
                        }else if(da.BLJG.indexOf('驳回')>-1){
                            da.BLJG = '驳回'
                        }else{
                            da.BLJG = ''
                        }
                    });
                    this.setState({
                        pageList: data.results
                    })
                }
            }
        },this);
    }
    onChange(value) {
        console.log(value);
    };
    goBasis(){
        console.log('this.props.location.state---------------------')
        console.log(this.props.location.state)
        this.props.history.push({ pathname: "/home/basis", state: {SQID: this.props.location.state.SQID,HJMC:this.props.location.state.HJMC} });
    }
    render()
    {
        const {industryInfo,pageInfo,pageList} = this.state
        // const SQTYPE_OBJ={
        //     '1': '“名”，即知名',
        //     '2': '“特”，即特色',
        //     '3': '“优”，即优质',
        //     '4': '“新”，即新兴',
        // }
        // let colorArr = {
        //     '待审核':'sg-color1',
        //     '审核通过':'sg-color2',
        //     '县审核驳回':'sg-color4',
        //     '县审核退回':'sg-color4',
        //     '市审核驳回':'sg-color4',
        //     '市审核退回':'sg-color4',
        //     '省审核驳回':'sg-color4',
        // }
        let year = pageInfo&&pageInfo.creating_time?new Date(pageInfo.creating_time).getFullYear():new Date().getFullYear()
        return (
            <div data-component="schedule">
                <div className="sg-history">
                    <div className="sg-history-title">{pageInfo.TASKNAME}</div>
                    {/* {year - 1}年“名特优新”申报评定 */}
                    <div className="sg-history-center" style={{paddingTop:0,paddingBottom:0}}>
                        <div className="sg-center-list sd-start">
                            <div className="sg-list-li sg-li-left1 sd-start">个体工商户名称</div>
                            <div className="sg-list-li sg-li-right1 sd-end">{industryInfo.ENTNAME}</div>
                        </div>

                        <div className="sg-center-list sd-start">
                            <div className="sg-list-li sg-li-left1 sd-start">统一社会信用代码</div>
                            <div className="sg-list-li sg-li-right1 sd-end">{industryInfo.UNISCID}</div>
                        </div>

                        <div className="sg-center-list sd-start">
                            <div className="sg-list-li sg-li-left1 sd-start">提交时间</div>
                            <div className="sg-list-li sg-li-right1 sd-end">{pageInfo&&pageInfo.creating_time}</div>
                        </div>
                        <div className="sd-middle" style={{height:'40px'}}>
                            <Button type="text" className="sd-list-bottom" onClick={()=>{this.goBasis()}}>查看详情</Button>
                        </div>
                    </div>
                    <div className="sg-center-ul" style={{display: pageList.length ? "block" : "none"}}>
                        {
                            pageList&&pageList.map((res,i)=>{
                                return <div className={`sg-ul-li sd-spaceBetween ${i<pageList.length-1?'sg-li-fake':''}`}>
                                    <div className="sg-li-left">
                                        <div className="sg-left-label"></div>
                                    </div>
                                    <div className="sg-li-right sd-start">
                                        <div className="sg-right-font">
                                            <div className="sg-font-title">{res.HJMC}</div>
                                            <div className="sg-font-tips">{res.BLSJ}</div>
                                            <div className="sg-font-tips" style={{display: res.BLJG.indexOf('驳回')>-1 || res.BLJG.indexOf('退回')>-1 ? "block" : "none"}}>修改意见：{res.BLYJ}</div>
                                        </div>
                                        <Button className={`sd-right-btn ${res.BLJG.indexOf('驳回')>-1 || res.BLJG.indexOf('退回')>-1?'sg-color4':''} ${res.BLJG.indexOf('通过')!==-1?'sg-color2':''}`} style={{display: res.BLJG ? "block" : "none"}}>{res.BLJG}</Button>
                                    </div>
                                </div>
                            })
                        }
                    </div>
                    <div className="sg-center-ul sd-columnCenter" style={{display: pageList.length ? "none" : "flex"}}>
                        <img className='sg-upload-img' alt='#' src={require('../../img/business/defined.png')}/>
                        <div className="sg-upload-tips">暂未进入审核步骤，请耐心等待！</div>
                    </div>
                </div>
            </div>
        )
    }
}

export default Index
